import { Subscription } from "../types";
import { oneTimeGrantsAccess } from "./subscriptionDisplay";

/**
 * CONTENT access check. The one_time gate (`oneTimeGrantsAccess`, the single
 * source of truth) is ADDITIVE: it is a no-op for recurring, so membership AND
 * finite keep the existing state-list result byte-identically. A one_time sub in
 * `waiting_for_gateway`/`not_paid`/`retrying` is "pago en proceso" → NO access.
 */
export const isSubscribed = (subscriptions: Subscription[], groupId) => {
  const userSubscriptions = !!subscriptions ? subscriptions : []
  const commonsSubscriptionsStates = ["active", "paid", "non_renewing", "renewal_retrying", "pending_invite"]
  const mpSubscriptionsStates = ["waiting_for_gateway", "not_paid", "retrying"]

  return userSubscriptions
    ?.filter(
      (suscription) => commonsSubscriptionsStates.includes(suscription.status) ||
        mpSubscriptionsStates.includes(suscription.status)
    )
    .filter(oneTimeGrantsAccess)
    .filter((suscription) => suscription.group.id === groupId).length > 0
};

/**
 * CHECKOUT-ROUTING access check used by the Subscription provider
 * (`checkIfIsSubscribed`). Standalone + exported so the gate is unit-testable —
 * it used to be an inline predicate inside the provider with zero coverage.
 *
 * IMPORTANT: its recurring state list intentionally DIFFERS from `isSubscribed`
 * (it includes 'completed' and excludes 'not_paid'/'renewal_retrying'/
 * 'pending_invite'). This mirrors the historical inline provider predicate
 * byte-identically — do NOT unify it with `isSubscribed`. Only the one_time gate
 * is shared, via `oneTimeGrantsAccess`, which is the sole guard against drift.
 */
export const isSubscribedForCheckout = (subscriptions: Subscription[], groupId): boolean => {
  const userSubscriptions = !!subscriptions ? subscriptions : []
  const commonSubscriptionStates = ["active", "paid", "non_renewing", "completed"]
  const mpSubscriptionStates = ["waiting_for_gateway", "retrying"]

  return userSubscriptions
    ?.filter((subscription) =>
      groupId === subscription?.group?.id &&
      oneTimeGrantsAccess(subscription) &&
      (commonSubscriptionStates.includes(subscription?.status) || mpSubscriptionStates.includes(subscription?.status))
    ).length > 0
};
